export default __webpack_public_path__ + "static/media/plattform_reflection.6958035b.png";